// 고객 문의·회신 주소 한 벌 — 발송 메일의 Reply-To 와 web 약관·처리방침이 같이 쓴다.
export const SUPPORT_EMAIL = "contact@buildpy.com";
// 운영자 받는 주소 — 새 시공사 가입 신청 알림이 여기로 간다.
export const OPERATOR_EMAIL = "admin@buildpy.com";
